import HttpClient from '@/common/boot/HttpClient'

const listarFormulariosDinamicos = async ({ commit }) => {
  commit('BUSCANDO', true);

  return await HttpClient.get(`/formularios/ctrl-formularios-dinamicos`).then(response => {
    const formularios = response.data.data;
    
    // Parse do corpo de cada formulário se for string JSON
    if (Array.isArray(formularios)) {
      formularios.forEach(formulario => {
        if (formulario.corpo && typeof formulario.corpo === 'string') {
          formulario.corpo = JSON.parse(formulario.corpo);
        }
      });
    }
    
    commit('INSERIR_LISTA_FORMULARIOS', formularios)
  })
  .finally( () => {
    commit('BUSCANDO', false);
  })
}

const listarExpressoesBooleanas = async ({ commit }) => {
  commit('BUSCANDO', true);

  return await HttpClient.get(`/formularios/ctrl-expressoes-booleanas`).then(response => {
    commit('INSERIR_LISTA_EXPRESSOES_BOOLEANAS', response.data.data)
  })
  .finally( () => {
    commit('BUSCANDO', false);
  })
}

const salvarFormularioDinamico = ({ commit, dispatch }, payload) => {
  commit('BUSCANDO', true);

  return HttpClient.post(`/formularios/ctrl-formularios-dinamicos`, payload).then(() => {
    dispatch('listarFormulariosDinamicos')
  })
  .finally( () => {
    commit('BUSCANDO', false);
  })
}

const recuperarFormularioDinamicoPorId = ({ commit }, payload) => {
  commit('BUSCANDO', true);

  // Adicionar parâmetros para carregar relações aninhadas
  const params = {
    ...payload,
    with: 'corpo.pco_formulario_campo_regras,corpo.expressoes_logicas_externas'
  }

  return HttpClient.get(`/formularios/ctrl-formularios-dinamicos/${payload.id}`, { params }).then((response) => {
    const formulario = response.data.data;
    
    // Parse do corpo se for string JSON
    if (formulario.corpo && typeof formulario.corpo === 'string') {
      formulario.corpo = JSON.parse(formulario.corpo);
    }
    
    commit('INSERIR_FORMULARIO_DINAMICO', formulario)
  })
  .finally( () => {
    commit('BUSCANDO', false);
  })
}

const recuperarListaDeFormulariosDinamicoPorId = async ({ commit }, payload) => {
  commit('BUSCANDO', true);

  const dadosRequisicao = payload.map(item => item.ctrl_formulario_dinamico_id)
  .filter(item => item !== null)
  

 await HttpClient.post(`/formularios/ctrl-formularios-dinamicos/lista`, dadosRequisicao).then(response => {
    const formularios = response.data.data;
    
    // Parse do corpo de cada formulário se for string JSON
    if (Array.isArray(formularios)) {
      formularios.forEach(formulario => {
        if (formulario.corpo && typeof formulario.corpo === 'string') {
          formulario.corpo = JSON.parse(formulario.corpo);
        }
      });
    }
    
    commit('INSERIR_FORMULARIO_DINAMICO', formularios)
 })


  // await payload.forEach(async item => {
  //   const formulario = await HttpClient.get(`/form/ctrl-formularios-dinamicos/lista`, payload)
  //   console.log('Cada formulario: ', formulario)
  //   formularios.push(formulario.data.data)
  // });

  // console.log('Lista de formularios: ', formularios)
}

const atualizarFormularioDinamico = ({ commit, dispatch }, payload) => {
  commit('BUSCANDO', true);

  return HttpClient.put(`/formularios/ctrl-formularios-dinamicos/${payload.id}`, payload).then(() => {
    dispatch('listarFormulariosDinamicos')
  })
  .finally( () => {
    commit('BUSCANDO', false);
  })
}

const deletarFormularioDinamico = ({ commit, dispatch }, payload) => {
  commit('BUSCANDO', true);

  return HttpClient.delete(`/formularios/ctrl-formularios-dinamicos/${payload.id}`).then(() => {
    dispatch('listarFormulariosDinamicos')
  })
  .finally( () => {
    commit('BUSCANDO', false);
  })
}

const inserirOptionsFormularioDinamico = ({ commit }, payload) => {
  commit('INSERIR_ITEM_OPTIONS', payload)
}

const listarFormularios = async ({ commit }) => {
  return listarFormulariosDinamicos({ commit })
}

const renderizarFormulario = async ({ commit, dispatch }, payload) => {
  try {
    commit('BUSCANDO', true);
    let formulariosId = payload.formulariosId;

    if (!isNaN(formulariosId)) {
      formulariosId = [{
        ctrl_formulario_dinamico_id: formulariosId,
        ctrl_tarefa_id: null
      }];
    }

    if (Array.isArray(formulariosId) && formulariosId.length > 0 && 
        !Object.prototype.hasOwnProperty.call(formulariosId[0], 'ctrl_formulario_dinamico_id')) {
      await dispatch('recuperarListaDeFormulariosDinamicoPorId', 
        formulariosId.map(id => ({ ctrl_formulario_dinamico_id: id }))
      )
    } else {
      // Buscar formulário único ou lista formatada
      if (formulariosId.length === 1) {
        await dispatch('recuperarFormularioDinamicoPorId', { 
          id: formulariosId[0].ctrl_formulario_dinamico_id 
        })
      } else {
        await dispatch('recuperarListaDeFormulariosDinamicoPorId', formulariosId)
      }
    }

    commit('BUSCANDO', false);
  } catch (error) {
    console.error('Erro ao renderizar formulário:', error)
    commit('BUSCANDO', false);
  }
}

const salvarDadosFormulario = ({ commit }, payload, endpoint) => {
  commit('BUSCANDO', true);
  
  const url = endpoint || '/formularios/ctrl-formularios-dinamicos'
  
  return HttpClient.post(url, payload).then(response => {
    return response
  }).finally(() => {
    commit('BUSCANDO', false);
  })
}

const inserirOptions = ({ commit }, payload) => {
  return inserirOptionsFormularioDinamico({ commit }, payload)
}

export {
  listarFormulariosDinamicos,
  salvarFormularioDinamico,
  atualizarFormularioDinamico,
  deletarFormularioDinamico,
  listarExpressoesBooleanas,
  recuperarFormularioDinamicoPorId,
  inserirOptionsFormularioDinamico,
  recuperarListaDeFormulariosDinamicoPorId,
  listarFormularios,
  renderizarFormulario,
  salvarDadosFormulario,
  inserirOptions
}